var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#0DA9B9",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 10.0001H10.6667C10.4899 10.0001 10.3203 10.0703 10.1953 10.1953C10.0703 10.3204 10 10.4899 10 10.6667V18.6667C10 18.8436 10.0703 19.0131 10.1953 19.1382C10.3203 19.2632 10.4899 19.3334 10.6667 19.3334H13.3334C13.5102 19.3334 13.6797 19.2632 13.8048 19.1382C13.9298 19.0131 14 18.8436 14 18.6667V10.6667C14 10.4899 13.9298 10.3204 13.8048 10.1953C13.6797 10.0703 13.5102 10.0001 13.3334 10.0001ZM12.6667 18.0001H11.3334V11.3334H12.6667V18.0001ZM18.6667 4.66675H16C15.8232 4.66675 15.6536 4.73699 15.5286 4.86201C15.4036 4.98703 15.3334 5.1566 15.3334 5.33341V18.6667C15.3334 18.8436 15.4036 19.0131 15.5286 19.1382C15.6536 19.2632 15.8232 19.3334 16 19.3334H18.6667C18.8435 19.3334 19.0131 19.2632 19.1381 19.1382C19.2631 19.0131 19.3334 18.8436 19.3334 18.6667V5.33341C19.3334 5.1566 19.2631 4.98703 19.1381 4.86201C19.0131 4.73699 18.8435 4.66675 18.6667 4.66675ZM18 18.0001H16.6667V6.00008H18V18.0001ZM8.00002 14.0001H5.33335C5.15654 14.0001 4.98697 14.0703 4.86195 14.1953C4.73692 14.3204 4.66669 14.4899 4.66669 14.6667V18.6667C4.66669 18.8436 4.73692 19.0131 4.86195 19.1382C4.98697 19.2632 5.15654 19.3334 5.33335 19.3334H8.00002C8.17683 19.3334 8.3464 19.2632 8.47142 19.1382C8.59645 19.0131 8.66669 18.8436 8.66669 18.6667V14.6667C8.66669 14.4899 8.59645 14.3204 8.47142 14.1953C8.3464 14.0703 8.17683 14.0001 8.00002 14.0001ZM7.33335 18.0001H6.00002V15.3334H7.33335V18.0001Z",
    fill: "#007FA1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.66669,
    y: 10,
    width: 9.33333,
    height: 1.33333,
    rx: 0.666667,
    fill: "#007FA1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatic);
export default __webpack_public_path__ + "static/media/static.1a5cc7d4f7496bbeb1eed96518cc3c47.svg";
export { ForwardRef as ReactComponent };